import { MY_WORK_DEFAULT_OPENED_GROUPS } from '../../../constants';
import { IMyWorkClosedGroups } from '../../types';
import { MY_WORK_CLOSED_GROUPS_LOCALSTORAGE } from '../types';

export const getClosedGroupsLocalStorage = (): IMyWorkClosedGroups => {
    const data = localStorage.getItem(MY_WORK_CLOSED_GROUPS_LOCALSTORAGE);
    const closedGroups = data ? JSON.parse(data) : MY_WORK_DEFAULT_OPENED_GROUPS;
    return closedGroups;
}
